import TextInput from './TextInput';

export * from './types';

export default TextInput;
